import React, { useState } from 'react';

const InputCheckbox = ({
  name,
  title,
  style,
  className,
  onChange,
  htmlTitle,
}) => {
  const [id] = useState(uuidv4());
  return (
      <div className={className} style={style}>
        <div className="align-center">
          <div className="columns" style={{ paddingLeft: 0 }}>
            <label
              className="checkout-info__checkbox-label"
              htmlFor={id}
              style={{ display: 'flex', alignItems: 'center', whiteSpace: 'normal' }}
            >
              <input
                className="checkout-info__checkbox-input"
                type="checkbox"
                name={name}
                id={id}
                onChange={onChange}
                style={{ marginRight: '.5rem' }}
              />

              {htmlTitle ? (
                <span
                  className="label__tos-text"
                  dangerouslySetInnerHTML={{ __html: htmlTitle }}
                ></span>
              ) : (
                <span>{title}</span>
              )}
            </label>
          </div>
        </div>
      </div>
  );
};

const uuidv4 = () => {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );
};

export default InputCheckbox;
